import * as React from 'react';
import { Loader, LoaderSize, LoaderTheme } from '../Loader/Loader';

function PageLoader() {
    return <div>
        <Loader theme={LoaderTheme.Dark} size={LoaderSize.Big} center={true} />
    </div>;
}

export default PageLoader;
